export default "__VITE_ASSET__CBb$skaN__"